// Dev harness — simulates the Single-SPA host shell so `npm run dev`
// boots the admin parcel through the same lifecycle production hosts use.
import { bootstrap, mount, unmount } from '@/root-app';
import { env } from '@/env';

interface HarnessProps {
  // Per services/admin-web/mfe.config.js editableProps.
  name: string;
  apiBaseUrl: string;
  wsBaseUrl: string;
  adminJwt?: string;
  salesforceId?: string;
  themeTokens?: Record<string, string>;
  locale: string;
  domElement: HTMLElement;
}

const MOUNT_ID = 'single-spa-application:admin-auctions';

function ensureMountNode(): HTMLElement {
  let node = document.getElementById(MOUNT_ID);
  if (!node) {
    node = document.createElement('div');
    node.id = MOUNT_ID;
    document.body.appendChild(node);
  }
  return node;
}

function buildProps(): HarnessProps {
  return {
    name: 'admin-auctions',
    apiBaseUrl: env.apiBaseUrl,
    wsBaseUrl: env.wsBaseUrl,
    locale: 'en-US',
    domElement: ensureMountNode(),
    // adminJwt + salesforceId stay undefined in the dev harness — the
    // mock SSO login screen issues a JWT after the user picks a role.
  };
}

async function boot(): Promise<void> {
  const props = buildProps();
  await bootstrap(props as unknown as Parameters<typeof bootstrap>[0]);
  await mount(props as unknown as Parameters<typeof mount>[0]);
}

declare global {
  interface Window {
    __adminAuctionsUnmount?: () => Promise<unknown>;
  }
}
window.__adminAuctionsUnmount = async () => {
  return unmount(buildProps() as unknown as Parameters<typeof unmount>[0]);
};

void boot();
